import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./auth";

export const ProtectedRoute: React.FC = () => {
  const { userId, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (!userId) {
    const loginUrl = `/api/log-in.php?redirect=${encodeURIComponent(
      location.pathname
    )}`;
    window.location.href = loginUrl;
    return null;
  }

  return <Outlet />;
};
